import { defineQuery as E } from "bitecs";
import "../../core/ecs/components.js";
import * as f from "three";
import "../../core/validation/schemas.js";
import { WorldTransform as t } from "../transforms/components.js";
import "../transforms/systems.js";
import { MainCamera as S, Renderer as p } from "./components.js";
import { initializeInstancedMesh as P, findAvailableInstanceSlot as g, MAX_TOTAL_INSTANCES as C, resizeInstancedMesh as R, PERFORMANCE_WARNING_THRESHOLD as T, RendererShape as h, SHADOW_CONFIG as u } from "./utils.js";
const m = new f.Matrix4(), M = new f.Vector3(), A = new f.Quaternion(), l = new f.Vector3(), N = E([S, t]);
function L(o, e, r = !1) {
  const i = r ? o.unlitMeshPools : o.meshPools, s = r ? o.unlitMaterial : o.material;
  let a = i.get(e);
  if (!a) {
    const n = o.geometries.get(e);
    if (!n) return null;
    a = P(n, s), i.set(e, a), o.scene.add(a);
  }
  return a;
}
function D(o, e, r, i, s = !1) {
  let a = r.entityInstances.get(e);
  if (!a) {
    let n = g(o, m);
    if (n === null) {
      if (r.totalInstanceCount >= C)
        throw new Error(
          `Maximum total instances (${C}) exceeded. Cannot render entity ${e}. Consider reducing the number of rendered objects.`
        );
      const c = p.shape[e], d = r.geometries.get(c);
      if (!d) return o;
      const I = s ? r.unlitMeshPools : r.meshPools, w = s ? r.unlitMaterial : r.material;
      if (o = R(o, d, w, r.scene), I.set(c, o), n = g(o, m), n === null) return o;
    }
    a = { poolId: p.shape[e], instanceId: n, unlit: s }, r.entityInstances.set(e, a), r.totalInstanceCount++, !r.hasShownPerformanceWarning && r.totalInstanceCount >= T && (console.warn(
      `Performance warning: ${r.totalInstanceCount} rendered instances. Consider optimizing your scene or reducing object count for better performance.`
    ), r.hasShownPerformanceWarning = !0);
  }
  if (i.hasComponent(e, t)) {
    if (M.set(
      t.posX[e],
      t.posY[e],
      t.posZ[e]
    ), A.set(
      t.rotX[e],
      t.rotY[e],
      t.rotZ[e],
      t.rotW[e]
    ), l.set(
      t.scaleX[e],
      t.scaleY[e],
      t.scaleZ[e]
    ), a.poolId === h.SPHERE) {
      const c = p.sizeX[e] / 2;
      l.x *= c, l.y *= c, l.z *= c;
    } else
      l.x *= p.sizeX[e], l.y *= p.sizeY[e], l.z *= p.sizeZ[e];
    m.compose(M, A, l), o.setMatrixAt(a.instanceId, m), o.instanceMatrix.needsUpdate = !0;
    const n = new f.Color(p.color[e]);
    o.setColorAt(a.instanceId, n), o.instanceColor && (o.instanceColor.needsUpdate = !0);
  }
  return o;
}
function Y(o, e, r) {
  const i = r.entityInstances.get(e);
  if (i) {
    const s = new f.Matrix4();
    s.makeScale(0, 0, 0), o.setMatrixAt(i.instanceId, s), o.instanceMatrix.needsUpdate = !0;
  }
}
function Z(o, e) {
  const r = N(e.world);
  let i = null;
  for (const I of r) {
    i = I;
    break;
  }
  if (i === null) return;
  const s = o.lights.directional;
  if (!s) return;
  const a = new f.Vector3(
    t.posX[i],
    t.posY[i],
    t.posZ[i]
  ), n = s.shadow.camera, c = a.clone().add(
    u.LIGHT_DIRECTION.clone().multiplyScalar(
      u.LIGHT_DISTANCE
    )
  );
  s.position.copy(c), s.target.position.copy(a), s.target.updateMatrixWorld();
  const d = u.CAMERA_RADIUS;
  n.left = -d, n.right = d, n.top = d, n.bottom = -d, n.near = u.NEAR_PLANE, n.far = u.FAR_PLANE, n.position.copy(c), n.lookAt(a), n.updateProjectionMatrix(), n.updateMatrixWorld();
}
export {
  L as getOrCreateMesh,
  Y as hideInstance,
  D as updateInstance,
  Z as updateShadowCamera
};
//# sourceMappingURL=operations.js.map
